import type { WorksheetRules } from '../as400CellRuleKinds';

/**
 * The Stock Add worksheet's own rules, on top of its columns' character limits
 * and number formats. Append new entries; keep one ticket's entries together
 * under its comment.
 */
export const STOCK_ADD_SHEET_RULES: WorksheetRules = {
  rules: [],
  autoFills: [],
  addDefaults: [],
};
